module.exports = __webpack_public_path__ + "img/dna-analysis.9474d0b8.svg";